import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling

(function () {
	document.querySelectorAll("[data-tippy-content]").forEach((el) => {
		const toolTip = tippy(el, {
			theme: "acc",
			// hideOnClick: "toggle", // debug
			// trigger: "click", // debug
		});

		el.addEventListener("click", (e) => {
			// Disable everything except a submit button on a form
			if (!el.getAttribute('[type="submit"]')) {
				e.preventDefault();
			}
		});
	});
})();
